import { render, staticRenderFns } from "./SupplierStatement.vue?vue&type=template&id=7634d93e&scoped=true"
import script from "./SupplierStatement.vue?vue&type=script&lang=js"
export * from "./SupplierStatement.vue?vue&type=script&lang=js"
import style0 from "./SupplierStatement.vue?vue&type=style&index=0&id=7634d93e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634d93e",
  null
  
)

export default component.exports